import React from 'react';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

const styles = theme =>({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
    backgroundColor: grey[300],
  },
});

const Info = (props) => {
  const { classes, children, title, actions } = props;

  return(
    <Card className={classes.root}>
        {title &&
          <div>
            <CardContent>
              <Typography variant="subheading">
                {title}
              </Typography>
            </CardContent>
            <Divider />
          </div>
        }
        {children}
    </Card>
  );
};

export default withStyles(styles)(Info);



// WEBPACK FOOTER //
// ./src/components/Info/Info.jsx